/**
 * Bề ngang MONG MUỐN của một ô ảnh, pixel.
 *
 * CEO chốt 26/09/2026: gấp đôi 168 → 336. Một hằng nuôi CẢ 11 màn — đổi một số
 * ở đây là mọi màn to theo, không phải đi sửa từng chỗ.
 */
export const TILE_TARGET_WIDTH = 336;

/**
 * Cỡ ảnh cho ô tường ảnh: bản "md" (cạnh dài 768px).
 *
 * CEO dặn 30/09/2026: ảnh nào cũng phải nét mà tệp đừng nặng lố. Ô rộng tới
 * `TILE_TARGET_WIDTH` — màn nét gấp đôi cần ~670 điểm ảnh, nên bản "thumb"
 * 256px (vừa cho ô 168 cũ) bị kéo giãn gần 3 lần, nhoè thấy rõ. Bản "lg"
 * 1600px nặng gấp ~4 lần bản "md" mà ở cỡ ô mắt không thấy khác — để dành cho
 * khung xem lớn. Cùng cỡ màn Kho ảnh và tường ảnh khách vẫn dùng.
 */
export const TILE_PHOTO_VARIANT = "md";

/**
 * Khe giữa hai ô, pixel. Lấy từ dự án PHOTO và CEO đã duyệt kiểu đó: khe hẹp
 * để mắt đọc cả lưới như một mảng ảnh, không như một bảng thẻ.
 */
export const TILE_GAP = 2;

const MIN_LANES = 2;
const MAX_LANES = 10;

/**
 * Số làn cho một bề ngang.
 *
 * `ceil` chứ KHÔNG `round`: làm tròn xuống thì ô phình VƯỢT cỡ mong muốn
 * (830px ÷ 2 làn = ô 415px trong khi cỡ đặt là 336). `ceil` giữ ô luôn ≤ cỡ
 * đặt, thừa chỗ thì chia đều chứ không dồn vào ô.
 *
 * `targetWidth` chỉ để cho những chỗ ảnh KHÔNG phải nội dung chính — dải ảnh
 * xác nhận trong cột hẹp, ô xem trước cạnh biểu mẫu. Tường ảnh thì KHÔNG
 * truyền, để một hằng nuôi cả chúng: đổi một số là mọi tường to theo.
 *
 * `width` bằng 0 nghĩa là CHƯA ĐO ĐƯỢC (khối còn ẩn, ví dụ thẻ chưa mở) — trả
 * mặc định chứ không trả 0 làn, vì chỗ gọi chia cho số này. Người gọi phải vẽ
 * lại khi khối hiện ra; xem chú thích trong PhotoMasonry.
 */
export function laneCount(width: number, targetWidth = TILE_TARGET_WIDTH): number {
  if (!Number.isFinite(width) || width <= 0) return MIN_LANES;
  const target = Number.isFinite(targetWidth) && targetWidth > 0 ? targetWidth : TILE_TARGET_WIDTH;
  return Math.max(MIN_LANES, Math.min(MAX_LANES, Math.ceil(width / target)));
}

/**
 * Làn của item thứ `index`.
 *
 * Rải theo HÀNG: hàng đầu là 0,1,2… `column-count` của CSS xếp theo CỘT nên số
 * tấm chạy 01-04-06-09 — thợ tra "ảnh 03" không thấy nó ở hàng đầu.
 */
export function laneOf(index: number, lanes: number): number {
  return index % lanes;
}
